(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
		popupSliderInit(true);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	swiperInit();
})();

document.addEventListener("DOMContentLoaded", function () {
	const mediaSliders = document.querySelectorAll(".js-media-list.swiper");

	mediaSliders.forEach((slider) => {
		new Swiper(slider, {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 8,
			navigation: {
				nextEl: slider.parentElement.querySelector(".swiper-button-next"),
				prevEl: slider.parentElement.querySelector(".swiper-button-prev"),
			},
			pagination: {
				el: slider.parentElement.querySelector(".swiper-pagination"),
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1,
					spaceBetween: 12,
				},
			},
		});
	});
});
